if (!customElements.get('ds-featured-brands-marquee')) {
  class DsFeaturedBrandsMarquee extends HTMLElement {
    connectedCallback() {
      this._slider = this.querySelector('.ds-fbm__slider');
      this._wrapper = this.querySelector('.ds-fbm__marquee-wrapper');
      this._sliderWrap = this.querySelector('.ds-fbm__slider-wrap');
      this._toggle = this.querySelector('[data-ds-fbm-toggle]');
      
      if (!this._slider || !this._wrapper || !this._sliderWrap) return;

      this._originalTrack = this._wrapper.querySelector('.ds-fbm__track');
      
      if (!this._originalTrack) return;

      const autoplay = this._slider.dataset.autoplay === 'true';
      this._baseDuration = parseFloat(this._slider.dataset.duration) || 20;

      this._slider.style.setProperty('--marquee-duration', `${this._baseDuration}s`);
      this._slider.style.setProperty('--marquee-play-state', autoplay ? 'running' : 'paused');

      this._labelPlay = this.dataset.labelPlay || 'Play';
      this._labelPause = this.dataset.labelPause || 'Pause';

      if (this._toggle) {
        this._toggle.dataset.state = autoplay ? 'playing' : 'paused';
        this._toggle.addEventListener('click', this._onToggle);
      }

      this._waitForImages().then(() => {
        this._buildLoop();
        this._slider.classList.add('is-ready');

        if ('ResizeObserver' in window) {
          this._ro = new ResizeObserver(() => this._scheduleRebuild());
          this._ro.observe(this._sliderWrap);
        } else {
          window.addEventListener('resize', this._scheduleRebuild);
        }
      });
    }

    disconnectedCallback() {
      if (this._toggle) this._toggle.removeEventListener('click', this._onToggle);
      if (this._ro) this._ro.disconnect();
      window.removeEventListener('resize', this._scheduleRebuild);
      if (this._rebuildTimer) clearTimeout(this._rebuildTimer);
    }

    _waitForImages() {
      const imgs = Array.from(this._originalTrack.querySelectorAll('img'));
      if (imgs.length === 0) return Promise.resolve();
      
      return Promise.all(
        imgs.map((img) => {
          if (img.complete && img.naturalWidth > 0) return Promise.resolve();
          return new Promise((resolve) => {
            img.addEventListener('load', resolve, { once: true });
            img.addEventListener('error', resolve, { once: true });
          });
        })
      );
    }

    _scheduleRebuild = () => {
      if (this._rebuildTimer) clearTimeout(this._rebuildTimer);
      this._rebuildTimer = setTimeout(() => this._buildLoop(), 150);
    };

    _buildLoop() {
      this._wrapper.innerHTML = '';
      this._wrapper.appendChild(this._originalTrack);

      const viewport = this._sliderWrap.offsetWidth;
      const trackWidth = this._originalTrack.offsetWidth;
      
      if (!viewport || !trackWidth) return;

      let copies = Math.ceil((viewport * 2) / trackWidth);
      
      if (copies < 2) copies = 2;
      if (copies % 2 !== 0) copies += 1;

      for (let i = 1; i < copies; i++) {
        const clone = this._originalTrack.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        this._wrapper.appendChild(clone);
      }
      
      const scaledDuration = this._baseDuration * (copies / 2);
      this._slider.style.setProperty('--marquee-duration', `${scaledDuration}s`);
    }

    _onToggle = () => {
      const playing = this._toggle.dataset.state === 'playing';
      this._toggle.dataset.state = playing ? 'paused' : 'playing';
      this._toggle.setAttribute('aria-pressed', playing ? 'true' : 'false');
      this._toggle.setAttribute('aria-label', playing ? this._labelPlay : this._labelPause);
      this._slider.style.setProperty('--marquee-play-state', playing ? 'paused' : 'running');
    };
  }

  customElements.define('ds-featured-brands-marquee', DsFeaturedBrandsMarquee);
}
